import {useTranslation} from 'react-i18next'
import {languageHasPrefix} from '~/utils/locales'
import {useHubspotChatLauncher} from '~/utils/useHubspotLauncher'
import {useRootLoaderData} from '~/utils/useRootLoaderData'

export default function SupportButton({
  className,
  onAfterClick
}: {
  className?: string
  onAfterClick?: () => void
}) {
  const {pathData, comingFromMymemory} = useRootLoaderData()
  const localizedSupportLanguage = ['en', 'it', 'de'].find(prefix =>
    languageHasPrefix({language: pathData?.language, prefix})
  )

  const shouldRedirect = comingFromMymemory || localizedSupportLanguage

  const {t} = useTranslation()

  const {handleHover, handleClick} = useHubspotChatLauncher()

  const onClick = () => {
    handleClick({removeLauncherBtn: true})
    onAfterClick?.()
  }

  return shouldRedirect ? (
    <a
      href={`https://support.laratranslate.com/${localizedSupportLanguage || 'en'}`}
      target="_blank"
      rel="noreferrer noopener"
      className={className}
    >
      {t('nav_pages.support')}
    </a>
  ) : (
    <button type="button" className={className} onClick={onClick} onMouseEnter={handleHover}>
      {t('nav_pages.support')}
    </button>
  )
}
